export const CANADA_COUNTRY_CODE = 'CA';
export const USA_COUNTRY_CODE = 'US';

export const ONE_LOWERCASE_TEST = 'one-lower-case';
export const ONE_UPPERCASE_TEST = 'one-upper-case';
export const ONE_NUMBER_TEST = 'one-number';
export const ONE_SPECIAL_CHAR_TEST = 'one-special-char';
export const PASSWORDS_MATCH_TEST = 'passwords-match';
